module.exports = "fonts/noto-sans-jp-v28-latin-500.woff2";